<template>
  <div class="banner">
    <a href="http://klotang.warecollective.com/" target="_blank"><img :src="image"></a>
  </div>
</template>
<script>
export default {
  name: 'Banner',
  data: function () {
    return {
      image: require('@/assets/images/ware2019.png')
    }
  }
}
</script>
<style scoped lang="scss">
  .banner {
    width: 100vw;
    background: #000;
    height: -webkit-fill-available;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: calc(100px + 10vw);
      height: auto;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Banner.vue